import { render, staticRenderFns } from "./PersonDetailsDialog.vue?vue&type=template&id=ddb55c68&scoped=true"
import script from "./PersonDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PersonDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonDetailsDialog.vue?vue&type=style&index=0&id=ddb55c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb55c68",
  null
  
)

export default component.exports